module.exports = __webpack_public_path__ + "img/carousel-image-2.4c25214d.png";